export default {
    namespaced: true,
    state: {
        busquedaTablero: {},
        verificarBusqueda: false,
        key: {
            tablero: 1,
        }
    },
    mutations: {
        asignarBusqueda(state, data){
            state.busquedaTablero = { ...data };
        },
        verificandoBusqueda(state, data){
            state.verificarBusqueda = data
        },
        cambiarKey(state, data) {
            switch(data.tipo){
                case 'T': 
                 state.key.tablero = data.key;
                break; 
            }
        },
        
    },
    actions: {
        
    }
}